import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 引入语言文件
import en from './locales/en.json';
import zh from './locales/zh.json';

// 使用 vue-i18n 插件
Vue.use(VueI18n);

// 配置 i18n
let navigatorLanguage = navigator.language
if (navigatorLanguage.startsWith('zh')) {
  navigatorLanguage = 'zh'
} else {
  navigatorLanguage = 'en'
}

const i18n = new VueI18n({
  locale: localStorage.getItem('s-locale') || navigatorLanguage || 'zh',  // 设置默认语言
  messages: {
    en,  // 引入英文翻译
    zh,  // 引入中文翻译
  },
});

export default i18n